import { render, staticRenderFns } from "./AgentRegisterSuccess.vue?vue&type=template&id=2ca884f5&"
import script from "./AgentRegisterSuccess.vue?vue&type=script&lang=js&"
export * from "./AgentRegisterSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AgentRegisterSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports